import React, { useState, useEffect } from "react";
import moment from "moment";
import { PDFViewer } from '@react-pdf/renderer';
import Button from "react-bootstrap/Button";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getBranches, updateBranch } from "../../../apis/branch";
import { authorizedRequests } from "../../../axios/axios-config";
import { toastify } from "../../../helperFunctions/toastify";
import {
    resetValue,
    setData,
    setForm,
} from "../../../redux/slices/StaffFormsSlices";
import { setPatientData } from "../../../redux/slices/patientSlice";
import DeleteModal from "../../SharedComponents/DeleteModal";
import FilterComponent from "../../SharedComponents/FilterComponent";
import hamburger from "../../../assets/images/hamburger.png";
import { SESSION_CURRENT_STATE } from "./PatientDetails";
import { useMemo } from "react";
import { Modal } from "react-bootstrap";
import billingIcon from "../../../assets/images/billing.png";
import {
    customDateSort,
    customStringSort,
    customTimeSort,
    exportData,
    getFormatedTime,
} from "../../../helperFunctions/utils";
import ComponentWrapepr from "../../SharedComponents/ComponentWrapper";
import DateInput from "../../SharedComponents/DateInput";
import { getPaymentMethodList } from "../../../apis/paymentMethod";

import { permissionTypes } from "../../../helperFunctions/routes";
import { PDFDownloadLink } from '@react-pdf/renderer';
import MyDoc from "../sessionPDF";
import SortComponent, {
    sortTypes,
} from "../../SharedComponents/SortComponents";
// import SortComponent, {
// sortTypes,
// } from "../../SharedComponents/SortComponents";
export default function SessionView() {
    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState([]);
    const [formData, setFormData] = useState([]);
    const [openContainer, setOpenContainer] = useState(false);
    const [itemToDel, setItemToDel] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [closeSessionModal, setCloseSessionModal] = useState(false);
    const [sortedArray, setSortedArray] = useState([]);
    const [selectedSessionData, setSelectedSessionData] = useState(null)
    const [paymentData, setPaymentData] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [showPDFModal, setShowPDFModal] = useState(false)
    const [stateDate, setStateDate] = useState(new Date());
    const [reloadSession, setReloadSession] = useState(true);
    const dispatch = useDispatch();

    const userData = useSelector((state) => state.userData.value);
    const isDoctor = userData?.department?.name?.toLowerCase()?.includes("doctor");

    const { appointmentDataForSession, sessionData, sessionForm } = useSelector(
        (state) => state.staffForm,
    );

    const getPaymentMethods = async () => {
        const { result, error } = await getPaymentMethodList();
        if (error) {
            return;
        }
        setPaymentMethods(result.data);
    };

    const getList = async () => {
        const { result, error } = await authorizedRequests({
            url: "appointment/listOfAppointments",
            method: "get",
        });
        if (error) {
            toastify(error.message ?? "unknown error occured", "error");
            return;
        }

        var tempArr = result.data
            ?.filter((app) => app.status !== "Not Show")
            .map((app) => {
                return {
                    id: app._id,
                    time: (app.startTime ?? "") + "-" + (app.endTime ?? ""),
                    patientName: app?.patient?.patientProfile?.fullName,
                    remarks: app?.remarks,
                    staff: app?.staff?.map((o) => {
                        return o.username;
                    }),
                    branch: app?.branch?._id,
                    staffAllData: app?.staff,
                    tag: app.tag.name,
                    isOpen: false,
                    // service: app.package.name,
                    startTime: app.startTime,
                    endTime: app.endTime,
                    status: app.status ? "Confirmed" : "Planned",
                    date: new Date(app.date).toDateString(),
                };
            })
            .filter((o) => {
                return (
                    o.date == new Date().toDateString() &&
                    !sessionData?.find((k) => k.appointmentId == o.id)
                );
            });

        dispatch(
            setData({
                parent: "appointmentDataForSession",
                value: tempArr,
            })
        );
        return;
    };

    const onRowEdit = async (id, index) => {
        var tempArr = formData[index];
        const valueObj = {
            appointment: tempArr?.appointment?._id,
            branch: tempArr?.branch?._id,
            date: tempArr?.date,
            location: tempArr.location,
            room: tempArr.room,
            consents: tempArr.consents?.map((o) => {
                return o._id;
            }),
            staff: tempArr.staff?.map((o) => {
                return o._id;
            }),
            status: tempArr.status,
            startTime: tempArr.startTime,
            endTime: tempArr.endTime,
            formStatus: "Edit",
            dataId: tempArr._id,
            patientMedicalHistory: {
                ...tempArr.patientMedicalHistory,
            },
            patientSOAP: {
                ...tempArr.patientSOAP,
            },
            patientConsents: [...tempArr.patientConsents],
            patientPrescriptionSheet: [...tempArr.patientPrescriptionSheet]
        };
        dispatch(
            setData({
                parent: "sessionForm",
                value: valueObj,
            })
        );
        navigate("/add-session", { state: { valueObj, session: tempArr } });
    };
    const onRowDelete = async (id) => {
        // tempArr =
        const { result, error } = await authorizedRequests({
            url: "session/updateSession",
            method: "post",
            data: {
                dataId: id,
                isDeleted: true,
            },
        });
        if (error) {
            toastify(error.message ?? "unknown error occured", "error");
            return;
        }
        getSessionList();
    };

    const getSessionList = async () => {
        const { result, error } = await authorizedRequests({
            url: "session/listOfSession",
            method: "get",
            params: {
                date: stateDate,
                status: "Completed"
            }
        });
        if (error) {
            toastify(error.message ?? "unknown error occured", "error");
            return;
        }
        var tempArr = result.data.map((app) => {
            return {
                id: app._id,
                appointmentId: app.appointment?._id,
                location: app?.branch?.location?.find(
                    (o) => o._id === app.location
                )?.name,
                room: app?.room,
                staff: app?.staff?.map((o) => {
                    return o.username;
                }),
                startTime: app.startTime,
                date: new Date(app.date).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                }),
                endTime: app.endTime,
                patientName:
                    app?.appointment?.patient?.patientProfile?.fullName,
                remarks: app?.appointment?.remarks,
                status: app.status,
            };
        });

        setFormData(result.data);

        dispatch(
            setData({
                parent: "sessionData",
                value: tempArr,
            })
        );
        return;
    };
    const openWaiting = (index) => {
        var tempArr = [...appointmentDataForSession];
        tempArr = tempArr.map((o, i) => {
            if (index === i) {
                return { ...o, isOpen: !o.isOpen };
            } else {
                return { ...o, isOpen: false };
            }
        });
        dispatch(
            setData({
                parent: "appointmentDataForSession",
                value: tempArr,
            })
        );
    };

    const addAppointment = async (appointment) => {
        dispatch(
            setData({
                parent: "sessionForm",
                value: {
                    appointment: appointment.id,
                    startTime: appointment.startTime,
                    branch: appointment.branch,
                    endTime: appointment.endTime,
                    date: appointment.date,
                    staff: appointment?.staffAllData?.map((o) => o._id),
                    formStatus: "New",
                },
            })
        );
        navigate("/add-session", {
            state: {
                valueObj: {
                    appointment: appointment.id,
                    startTime: appointment.startTime,
                    branch: appointment.branch,
                    endTime: appointment.endTime,
                    date: appointment.date,
                    staff: appointment?.staffAllData?.map((o) => o._id),
                    formStatus: "New",
                },
            },
        });
    };

    const handleTodaySession = async () => {
        const { result, error } = await authorizedRequests({
            url: "session/closeTodaySessions",
            method: "get",
        });
        setCloseSessionModal(false);
        if (!result?.data) {
            toastify(result?.message, "error");
            return;
        } else {
            toastify(result?.message, "success");
            setPaymentData(result.data)
            setShowPDFModal(true)
            return;
        }
    };

    useEffect(() => {
        getSessionList();
        getPaymentMethods();
        dispatch(resetValue("billingForm"));
        dispatch(resetValue("selectedSession"));
        dispatch(resetValue("sessionForm"));
    }, [stateDate]);

    useMemo(() => {
        getList();
    }, [sessionData, stateDate, reloadSession]);


    const handlePDFClick = async (session) => {
        setSelectedSessionData(session)
        const payload = {
            sessionId: session.id,
        };
        const result = await authorizedRequests({
            url: "payment/getPaymentbySessionId",
            method: "post",
            data: payload,
        });
        let data = result.result.data;
        data = { ...data, session: session }
        setPaymentData([data])
        setShowPDFModal(true)
    }

    const columns = [
        {
            name: (
                <div className="d-flex align-items-center" id="ovly2">
                    <span className="me-2">Date</span>
                    {
                        <FilterComponent
                            type="date"
                            array={sessionData}
                            setArray={setFilteredData}
                            value="date"
                        />
                    }
                </div>
            ),
            selector: (row) => row.date,
            wrap: true,
            width: "160px",
            sortable: true,
            sortFunction: (a, b) => customDateSort(a, b, "date"),
        },
        {
            name: (
                <div className="d-flex align-items-center" id="ovly2">
                    <span className="me-2">Location</span>
                    {
                        <FilterComponent
                            type="search"
                            array={
                                filteredData.length > 0
                                    ? filteredData
                                    : sessionData
                            }
                            setArray={setFilteredData}
                            value="location"
                        />
                    }
                </div>
            ),
            selector: (row) => row.location,
            wrap: true,
            width: "160px",
            sortable: true,
            sortFunction: (a, b) => customStringSort(a, b, "location"),
        },
        // {
        // 	name: (
        // 		<div className="d-flex align-items-center" id="ovly2">
        // 			<span className="me-2">Room No.</span>
        // 			{
        // 				<FilterComponent
        // 					type="search"
        // 					array={
        // 						filteredData.length > 0
        // 							? filteredData
        // 							: sessionData
        // 					}
        // 					setArray={setFilteredData}
        // 					value="room"
        // 				/>
        // 			}
        // 		</div>
        // 	),
        // 	selector: (row) => row.room,
        // 	wrap: true,
        // 	width: "160px",
        // 	sortable: true,
        // 	sortFunction: (a, b) => customStringSort(a, b, "room"),
        // },
        {
            name: (
                <div className="d-flex align-items-center" id="ovly2">
                    <span className="me-2">Patient</span>
                    {
                        <FilterComponent
                            type="search"
                            array={sessionData}
                            setArray={setFilteredData}
                            value="patientName"
                        />
                    }
                </div>
            ),
            selector: (row) => row.patientName,
            wrap: true,
            width: "160px",
            sortable: true,
            sortFunction: (a, b) => customStringSort(a, b, "patientName"),
        },
        {
            name: (
                <div className="d-flex align-items-center" id="ovly2">
                    <span className="me-2">Staff</span>
                    {
                        <FilterComponent
                            type="search"
                            array={sessionData}
                            setArray={setFilteredData}
                            subArray
                            value="staff"
                        />
                    }
                </div>
            ),
            selector: (row) => row.staff,
            wrap: true,
            width: "160px",
        },
        {
            name: (
                <div className="d-flex align-items-center" id="ovly2">
                    <span className="me-2">Remark</span>
                </div>
            ),
            selector: (row) => row.remarks,
            wrap: true,
            width: "160px",
            sortable: true,
            sortFunction: (a, b) => customStringSort(a, b, "remarks"),
        },
        {
            name: (
                <div className="d-flex align-items-center" id="ovly2">
                    <span className="me-2">Time In</span>
                </div>
            ),
            selector: (row) => row.startTime,
            wrap: true,
            width: "140px",
            sortable: true,
            sortFunction: (a, b) => customTimeSort(a, b, "startTime"),
        },
        // {
        // 	name: (
        // 		<div className="d-flex align-items-center" id="ovly2">
        // 			<span className="me-2">Time Out</span>
        // 		</div>
        // 	),
        // 	selector: (row) => row.endTime,
        // 	wrap: true,
        // 	width: "140px",
        // 	sortable: true,
        // 	sortFunction: (a, b) => customTimeSort(a, b, "endTime"),
        // },
        {
            name: (
                <div className="d-flex align-items-center" id="ovly2">
                    <span className="me-2">Status</span>
                    {
                        <FilterComponent
                            type="radio-search"
                            array={sessionData}
                            setArray={setFilteredData}
                            subArray
                            options={[
                                {
                                    id: "Cancelled",
                                    name: "Cancelled",
                                },
                                {
                                    id: "Pending",
                                    name: "Pending",
                                },
                                {
                                    id: "Completed",
                                    name: "Completed",
                                },
                            ]}
                            value="status"
                        />
                    }
                </div>
            ),
            selector: (row) => row.status,
            wrap: true,
            width: "160px",
        },
        {
            name: "Action",
            selector: (row) => row.action,
            width: isDoctor ? "80px" : "200px",
        },
    ];
    const data = (filteredData.length === 0 ? sessionData : filteredData)
        ?.map((e, index) => {
            return {
                id: e.id,
                index: index,
                date: e.date,
                startTime: getFormatedTime(e.startTime),
                // endTime: getFormatedTime(e.endTime),
                // room: e.room,
                location: e.location,
                patientName: e.patientName,
                remarks: e.remarks,
                staffText: e.staff?.join(","),
                statusText: e.status,
                status: (
                    <>
                        <div
                            style={{
                                minWidth: "85px",
                                paddingLeft: "0",
                                paddingRight: "0",
                            }}
                            className={`${e.status == "Completed"
                                ? "green-rounded-button"
                                : e.status == "Pending"
                                    ? "brown-rounded-button"
                                    : "red-rounded-button"
                                }`}
                        >
                            {`${e.status == "Completed"
                                ? "Completed"
                                : e.status == "Pending"
                                    ? "Pending"
                                    : e.status === "Closed"
                                        ? "Closed"
                                        : "Cancelled"
                                }`}
                        </div>
                    </>
                ),
                staff: (
                    <>
                        {e.staff.map((o) => {
                            return <div className="">{o}</div>;
                        })}
                    </>
                ),

                action: (
                    <div className="d-flex">
                        <React.Fragment>
                            {
                                !isDoctor && (
                                    <ComponentWrapepr
                                        permissionType={permissionTypes.UPDATE}
                                        moduleName={"Session"}
                                    >
                                        <div
                                            className="  cursor-pointer icon-width "
                                            onClick={() => {
                                                onRowEdit(e.id, index);
                                            }}
                                        >
                                            <i className="fa fa-pen"></i>
                                        </div>
                                    </ComponentWrapepr>
                                )
                            }
                            <ComponentWrapepr
                                permissionType={permissionTypes.UPDATE}
                                moduleName={"Session"}
                            >
                                <div
                                    className="  cursor-pointer icon-width"
                                    onClick={() => {
                                        const tempArr = formData[index];
                                        const valueObj = {
                                            appointment: tempArr?.appointment?._id,
                                            branch: tempArr?.branch?._id,
                                            date: tempArr.date,
                                            location: tempArr.location,
                                            room: tempArr.room,
                                            consents: tempArr.consents?.map((o) => {
                                                return o._id;
                                            }),
                                            staff: tempArr.staff?.map((o) => {
                                                return o._id;
                                            }),
                                            status: tempArr.status,
                                            startTime: tempArr.startTime,
                                            endTime: tempArr.endTime,
                                            formStatus: "Edit",
                                            dataId: tempArr._id,
                                            patientMedicalHistory: {
                                                ...tempArr.patientMedicalHistory,
                                            },
                                            patientSOAP: {
                                                ...tempArr.patientSOAP,
                                            },
                                            patientConsents: [
                                                ...tempArr.patientConsents,
                                            ],
                                            patientChart: [...tempArr.patientChart],
                                            patientPrescriptionSheet: [...tempArr.patientPrescriptionSheet],
                                            photoSession: tempArr.photoSession
                                        };
                                        dispatch(
                                            setData({
                                                parent: "sessionForm",
                                                value: valueObj,
                                            }),
                                        );
                                        dispatch(
                                            setPatientData(tempArr?.appointment?.patient),
                                        );
                                        if (!isDoctor) {
                                            localStorage.setItem(
                                                "session_current_state",
                                                SESSION_CURRENT_STATE.patientConsents,
                                            );
                                        } else {
                                            localStorage.setItem(
                                                "session_current_state",
                                                SESSION_CURRENT_STATE.patientMedicalHistory,
                                            );
                                        }
                                        navigate("/patient-details", {
                                            state: { valueObj },
                                        });
                                        // onRowEdit(e.id, index);
                                    }}
                                >
                                    <i
                                        className="fa fa-server"
                                        style={{ color: "#34556F" }}
                                    ></i>
                                </div>
                            </ComponentWrapepr>
                            {
                                !isDoctor && (
                                    <React.Fragment>
                                        <ComponentWrapepr
                                            permissionType={permissionTypes.CREATE}
                                            moduleName={"Billing"}
                                        >
                                            <div
                                                className="cursor-pointer icon-width"
                                                onClick={() => {
                                                    const sessionClicked = formData.find(
                                                        (o) => o?._id == e?.id,
                                                    );
                                                    navigate("/add-billing", {
                                                        state: { session: sessionClicked },
                                                    });
                                                    // onRowDelete(e.id, index);
                                                }}
                                            >
                                                <img
                                                    alt=""
                                                    src={billingIcon}
                                                    className=" "
                                                />
                                            </div>
                                        </ComponentWrapepr>

                                        <ComponentWrapepr
                                            permissionType={permissionTypes.DELETE}
                                            moduleName={"Session"}
                                        >
                                            <div
                                                className="  cursor-pointer icon-width"
                                                onClick={() => {
                                                    setItemToDel(e.id);
                                                    setOpenModal(true);
                                                    // onRowDelete(e.id, index);
                                                }}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </div>
                                        </ComponentWrapepr>

                                        {/* {e.status === 'Completed' &&
                                            <ComponentWrapepr
                                                permissionType={permissionTypes.REPORT}
                                                moduleName={"Report"}
                                            >
                                                <div
                                                >
                                                    <i className="fa fa-file" onClick={() => handlePDFClick(e)}></i>
                                                </div>
                                            </ComponentWrapepr>
                                        } */}
                                    </React.Fragment>
                                )
                            }
                        </React.Fragment>
                    </div>
                ),
            };
        })
        .reverse();
    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                justifyContent: "center",
                textAlign: "center",
            },
        },
    };

    const conditionalRowStyles = [
        {
            when: (row) => row,
            style: {
                borderWidth: "0px",
            },
        },
        {
            when: (row) => row.index % 2 === 1,
            style: {
                backgroundColor: "#f8f8f8",
                borderWidth: "0px",
            },
        },
    ];

    return (
        <>
            <div className="container p-0">
                <div className="mainHeading px-4">
                    <h1>
                        <i
                            className="fa fa-arrow-left cursor-pointer"
                            onClick={() => {
                                navigate(-1);
                            }}
                        ></i>
                        Sessions
                    </h1>
                    <div className="d-flex">
                        <div className="me-3" style={{ width: "200px" }}>
                            <DateInput
                                value={stateDate}
                                placeholder="Date"
                                shouldDisableDates={true}
                                onChange={(e) => {
                                    setStateDate(e);
                                }}
                            />
                        </div>
                        <Button
                            className="addItem me-3"
                            onClick={() => {
                                setCloseSessionModal(!closeSessionModal);
                            }}
                        >
                            End Session
                        </Button>
                        <Button
                            className="addItem me-3"
                            onClick={() => {
                                const tempDataArr = data?.map((o) => {
                                    return {
                                        Location: o.location,
                                        Room: o.room,
                                        "Patient Name": o.patientName,
                                        Staff: o?.staffText,
                                        Remarks: o.remarks,
                                        "Time In": o.startTime,
                                        "Time Out": o.endTime,
                                        status: o?.statusText,
                                    };
                                });
                                exportData(tempDataArr, "Session");
                            }}
                        >
                            Export
                        </Button>
                        <ComponentWrapepr
                            permissionType={permissionTypes.CREATE}
                            moduleName={"Session"}
                        >
                            <Button
                                className="addItem px-5"
                                onClick={() => {
                                    dispatch(resetValue("sessionForm"));
                                    // dispatch(
                                    // 	setData({
                                    // 		value: {
                                    // 			patient: "",
                                    // 			branch: "",
                                    // 			location: "",
                                    // 			startTime: "",
                                    // 			endTime: "",
                                    // 			package: "",
                                    // 			staff: [],
                                    // 			tag: "",
                                    // 			status: "true",
                                    // 			remarks: "",
                                    // 			formStatus: "New",
                                    // 			editId: null,
                                    // 		},
                                    // 		parent: "appointmentForm",
                                    // 	}),
                                    // );
                                    navigate("/add-session");
                                }}
                            >
                                + Add New
                            </Button>
                        </ComponentWrapepr>
                    </div>
                </div>
                {/* 
				<DeleteModal
					content="Confirm Branch Deletion?"
					onYes={removeBranch}
					onNo={handleClose}
					show={show}
				/> */}
                <div className="d-flex pb-3" style={{ overflowX: "auto" }}>
                    <div
                        style={{
                            width: !isDoctor ? `${openContainer
                                    ? "calc(100% - 400px)"
                                    : "calc(100% - 200px)"
                                }` : "100%",
                        }}
                    >
                        <DataTable
                            columns={columns}
                            data={data || []}
                            pagination
                            customStyles={customStyles}
                            conditionalRowStyles={conditionalRowStyles}
                        // responsive="true"
                        />
                    </div>
                    {openModal && (
                        <>
                            <Modal
                                centered
                                show={openModal}
                                onHide={() => {
                                    setItemToDel(null);

                                    setOpenModal(!openModal);
                                }}
                            >
                                <Modal.Body className="font-18">
                                    Confirm Session Deletion
                                    <div className="align-self-end m-3 d-flex">
                                        <Button
                                            className="me-3 delete-no ms-auto"
                                            onClick={() => {
                                                setOpenModal(false);
                                            }}
                                        >
                                            No
                                        </Button>
                                        <Button
                                            className="delete-yes"
                                            onClick={() => {
                                                onRowDelete(itemToDel);
                                                setOpenModal(false);
                                            }}
                                        >
                                            Yes
                                        </Button>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        </>
                    )}
                    <Modal
                        centered
                        show={closeSessionModal}
                        onHide={() => {
                            setItemToDel(null);

                            setOpenModal(!closeSessionModal);
                        }}
                    >
                        <Modal.Body className="font-18">
                            Are you sure want to end all the session for today ?
                            <div className="align-self-end m-3 d-flex">
                                <Button
                                    className="me-3 delete-no ms-auto"
                                    onClick={() => {
                                        setCloseSessionModal(false);
                                    }}
                                >
                                    No
                                </Button>
                                <Button
                                    className="delete-yes"
                                    onClick={() => {
                                        handleTodaySession()
                                    }}
                                >
                                    Yes
                                </Button>
                            </div>
                        </Modal.Body>
                    </Modal>


                    {
                        !isDoctor && (
                            <div
                                className={`${openContainer ? "open-animate" : "close-animate"
                                    }`}
                            >
                                <div className="header d-flex align-items-center">
                                    <img
                                        className="img img-fluid hamburgerIcon pointer"
                                        onClick={() => {
                                            setOpenContainer(!openContainer);
                                        }}
                                        src={hamburger}
                                        alt=""
                                    />
                                    <div className="heading">
                                        Today's{" "}
                                        {openContainer ? "Appointment List" : ""}
                                    </div>
                                </div>
                                {
                                    moment().isSame(moment(stateDate), "day") && (
                                        <React.Fragment>
                                            {appointmentDataForSession.length > 0 &&
                                                appointmentDataForSession.map((o, i) => {
                                                    return (
                                                        <div className="waiting-card">
                                                            <div
                                                                className={`d-flex pointer ${o.isOpen ? "top-bar" : "p-1"
                                                                    }`}
                                                                onClick={() => {
                                                                    // if (openContainer) {
                                                                    openWaiting(i);
                                                                    // }
                                                                }}
                                                            >
                                                                <div className="d-flex">
                                                                    <span className="top-text">
                                                                        {getFormatedTime(
                                                                            o.startTime,
                                                                        )}
                                                                    </span>
                                                                    <div
                                                                        className="top-text ms-3"
                                                                        style={{
                                                                            wordBreak: "break-all",
                                                                        }}
                                                                    >
                                                                        {o.patientName}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {o.isOpen && (
                                                                <div className="card-body">
                                                                    <div className="d-flex justify-content-between my-1">
                                                                        <span>
                                                                            Appointment Time
                                                                        </span>
                                                                        <span>
                                                                            {getFormatedTime(
                                                                                o.startTime,
                                                                            )}{" "}
                                                                            -{" "}
                                                                            {getFormatedTime(
                                                                                o.endTime,
                                                                            )}{" "}
                                                                        </span>
                                                                    </div>
                                                                    {o.staff.map((staf) => {
                                                                        return (
                                                                            <>
                                                                                <div className="d-flex justify-content-between my-1">
                                                                                    <span>
                                                                                        Staff
                                                                                    </span>
                                                                                    <span>
                                                                                        {staf}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}
                                                                    <div className="d-flex justify-content-between my-1">
                                                                        <span>Service</span>
                                                                        <span>{o.service}</span>
                                                                    </div>
                                                                    <div className="w-100 df-center my-2">
                                                                        <Button
                                                                            className="white-rounded-button"
                                                                            onClick={() => {
                                                                                // console.log(o);
                                                                                addAppointment(o);
                                                                            }}
                                                                        >
                                                                            Register session
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </React.Fragment>
                                    )
                                }
                            </div>
                        )
                    }
                </div>
            </div>
            {showPDFModal}
            <Modal
                centered
                show={showPDFModal}
                onHide={() => {
                    setShowPDFModal(false);
                    setReloadSession(!reloadSession);
                }}
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Session Report
                    </Modal.Title>
                </Modal.Header>

                <div className="pdf-btn">
                    <PDFViewer style={{ width: "100%", height: "800px" }}>
                        <MyDoc
                            payment={paymentData}
                            paymentMethods={paymentMethods}
                        />
                    </PDFViewer>
                </div>
            </Modal>
        </>
    );
}


